import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Message = _resolveComponent("Message")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-mt-4" }, {
    content: _withCtx(() => [
      (_ctx.dataset.meta)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            class: "p-datatable-sm kn-table",
            scrollable: true,
            scrollHeight: "40vh",
            value: _ctx.fieldsMetadata,
            stripedRows: "",
            rowHover: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "fieldAlias",
                header: _ctx.$t('managers.datasetManagement.fieldAlias'),
                sortable: true
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(data.fieldAlias), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                field: "Type",
                header: _ctx.$t('importExport.catalogFunction.column.type'),
                sortable: true
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_Dropdown, {
                    class: "kn-material-input",
                    style: _ctx.wizardDescriptor.style.maxwidth,
                    modelValue: data.Type,
                    "onUpdate:modelValue": ($event: any) => (data.Type = $event),
                    options: _ctx.valueTypes,
                    optionLabel: "value",
                    optionValue: "name",
                    onChange: _ctx.saveFieldsMetadata,
                    disabled: true
                  }, null, 8, ["style", "modelValue", "onUpdate:modelValue", "options", "onChange"])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                field: "fieldType",
                header: _ctx.$t('managers.datasetManagement.fieldType'),
                sortable: true
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_Dropdown, {
                    class: "kn-material-input",
                    style: _ctx.wizardDescriptor.style.maxwidth,
                    modelValue: data.fieldType,
                    "onUpdate:modelValue": ($event: any) => (data.fieldType = $event),
                    options: _ctx.fieldMetadataTypes,
                    optionLabel: "value",
                    optionValue: "value",
                    onChange: _ctx.saveFieldsMetadata
                  }, null, 8, ["style", "modelValue", "onUpdate:modelValue", "options", "onChange"])
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          }, 8, ["value"]))
        : (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_Message, {
              severity: "info",
              closable: false
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.metadataInfo')), 1)
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }))
}